import {message, Modal} from "antd";
import {AndroidOutlined, AppleOutlined, WindowsOutlined} from "@ant-design/icons";
import {isProdEnv} from "@/util/isProdEnv";

interface DownloadPointItem {
  name: string;
  icon: React.ReactNode;
  url: string;
  url_testEnv?: string;
}

const downloadPoints: DownloadPointItem[] = [
  {
    name: 'Windows',
    icon: <WindowsOutlined style={{ fontSize: '30px' }}/>,
    // url: 'https://platform.prod.iswan.cc/api/appVersion/latest/download/edatlink-app-windows',
    url: '',
    url_testEnv: 'https://platform.preview.iswan.cc:25000/api/appVersion/latest/download/edatlink-app-windows'
  },
  {
    name: 'Android',
    icon: <AndroidOutlined style={{ fontSize: '30px' }}/>,
    // url: 'https://platform.prod.iswan.cc/api/appVersion/latest/download/edatlink-app-android',
    url: '',
    url_testEnv: 'https://platform.preview.iswan.cc:25000/api/appVersion/latest/download/edatlink-app-android'
  },
  {
    name: 'iOS',
    icon: <AppleOutlined style={{ fontSize: '30px' }}/>,
    // url: 'https://platform.prod.iswan.cc/api/appVersion/latest/download/edatlink-app-ios',
    url: '',
    url_testEnv: 'https://platform.preview.iswan.cc:25000/api/appVersion/latest/download/edatlink-app-ios'
  },
  {
    name: 'macOS',
    icon: <AppleOutlined style={{ fontSize: '30px' }}/>,
    // url: 'https://platform.prod.iswan.cc/api/appVersion/latest/download/edatlink-app-macos',
    url: '',
    url_testEnv: 'https://platform.preview.iswan.cc:25000/api/appVersion/latest/download/edatlink-app-macos'
  },
]

export interface AppDownloadModalProps {
  show: boolean
  closeFn: () => void
}

const AppDownloadModal: React.FC<AppDownloadModalProps> = (props) => {

  const getWidth = () => {
    const num = downloadPoints.length
    return num * 120 + (num - 1) * 30 + 24
  }

  function handleDownload(item: DownloadPointItem) {
    if (isProdEnv()){
      if (!item.url) {
        message.info('敬请期待')
        return
      }
      window.open(item.url);
      return;
    }
    window.open(item.url_testEnv);
  }

  return <>
    <Modal
      open={props.show}
      onCancel={props.closeFn}
      width={getWidth()}
      centered
      title={'APP下载'}
      footer={null}
    >
      <div className={`w-full h-full flex justify-center items-center gap-[30px] py-[30px]`}>
        {
          downloadPoints.map((item) => (
            <div
              key={item.name}
              onClick={() => handleDownload(item)}
              className={`
                w-[120px] h-[120px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] cursor-pointer
                bg-gray-100 hover:bg-gray-200 transition-all
              `}
            >
              <div>{item.icon}</div>
              <div>{item.name}</div>
            </div>
          ))
        }
      </div>
    </Modal>
  </>
}

export default AppDownloadModal;
